import React, { memo, SyntheticEvent } from 'react';
import classNames from 'classnames';

import { ReactComponent as PlusIcon } from 'assets/images/icons/plus.svg';
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg';
import { ReactComponent as DocumentIcon } from 'assets/images/icons/document.svg';

import { Button } from 'ui/Button';

import style from 'assets/scss/ui/uploader.module.scss';

interface FileUploaderProps {
  name: string;
  file: File | undefined;
  originalFilename?: string;
  onRemove?: (event?: SyntheticEvent) => void;
  onUpload: (file: File) => void;
  className?: string;
  error?: string;
  title?: string;
  accept?: string;
}

export const FileUploader: React.FC<FileUploaderProps> = ({
  name,
  file,
  originalFilename,
  onUpload,
  onRemove,
  className,
  error,
  title = 'Object questionnaire',
  accept,
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    const newFiles = Array.from(e.target.files);

    onUpload(newFiles?.[0]);

    e.target.value = '';
  };

  return (
    <div className={classNames(style['file-uploader'], className)}>
      <label htmlFor={name} className={style['file-uploader__label']}>
        <span className={style['file-uploader__title']}>
          {title}
        </span>

        {!(file || originalFilename) && (
          <div className={style['file-uploader__subtitle']}>
            <PlusIcon />

            <span>Attach file</span>
          </div>
        )}

        {(!!file || !!originalFilename) && (
          <div
            className={classNames(
              style['file-uploader__subtitle'],
              style['file-uploader__subtitle-file'],
            )}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <DocumentIcon />

            {file?.name || originalFilename}

            {!!onRemove && (
              <Button onClick={onRemove} variant="icon" type="button">
                <CloseIcon />
              </Button>
            )}
          </div>
        )}
      </label>

      <input
        id={name}
        type="file"
        accept={accept}
        onChange={handleFileChange}
        className={style['file-uploader__input']}
      />

      {error && <span className={style['file-uploader__error']}>{error}</span>}
    </div>
  );
};

export default memo(FileUploader);
